"use strict";
/// <reference path="./types.d.ts" />
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObjects = void 0;
const Comlink = __importStar(require("comlink"));
const sql_wasm_js_1 = __importDefault(require("../sql.js/dist/sql-wasm.js"));
const sql_wasm_wasm_1 = __importDefault(require("../sql.js/dist/sql-wasm.wasm"));
const lazyFile_1 = require("./lazyFile");
const vtab_1 = require("./vtab");
sql_wasm_wasm_1.default;
// https://gist.github.com/frankier/4bbc85f65ad3311ca5134fbc744db711
function initTransferHandlers(sql) {
    Comlink.transferHandlers.set("WORKERSQLPROXIES", {
        canHandle: (obj) => {
            let isDB = obj instanceof sql.Database;
            let hasDB = obj && obj.db && obj.db instanceof sql.Database; // prepared statements
            return isDB || hasDB;
        },
        serialize(obj) {
            const { port1, port2 } = new MessageChannel();
            Comlink.expose(obj, port1);
            return [port2, [port2]];
        },
        deserialize: (port) => { },
    });
}
async function init(wasmfile) {
    const sql = await sql_wasm_js_1.default({
        locateFile: (_file) => wasmfile,
    });
    initTransferHandlers(sql);
    return sql;
}
function toObjects(res) {
    return res.flatMap(r => r.values.map((v) => {
        const o = {};
        for (let i = 0; i < r.columns.length; i++) {
            o[r.columns[i]] = v[i];
        }
        return o;
    }));
}
exports.toObjects = toObjects;
async function fetchConfigs(configsOrUrls) {
    const configs = configsOrUrls.map(async (config) => {
        if (config.from === "jsonconfig") {
            const configUrl = new URL(config.configUrl, location.href);
            const req = await fetch(configUrl.toString());
            if (!req.ok) {
                console.error("httpvfs config error", await req.text());
                throw Error(`Could not load httpvfs config: ${req.status}: ${req.statusText}`);
            }
            const configOut = await req.json();
            return {
                from: "inline",
                // resolve url relative to config file
                config: configOut.serverMode === "chunked"
                    ? {
                        ...configOut,
                        urlPrefix: new URL(configOut.urlPrefix, configUrl).toString(),
                    }
                    : {
                        ...configOut,
                        url: new URL(configOut.url, configUrl).toString(),
                    },
                virtualFilename: config.virtualFilename,
            };
        }
        else {
            return config;
        }
    });
    return Promise.all(configs);
}
const mod = {
    db: null,
    inited: false,
    sqljs: null,
    bytesRead: 0,
    async SplitFileHttpDatabase(wasmUrl, configs, mainVirtualFilename, maxBytesToRead = Infinity) {
        if (this.inited)
            throw Error(`sorry, only one db is supported right now`);
        this.inited = true;
        if (!this.sqljs) {
            this.sqljs = init(wasmUrl);
        }
        const sql = await this.sqljs;
        this.bytesRead = 0;
        let requestLimiter = (bytes) => {
            if (this.bytesRead + bytes > maxBytesToRead) {
                this.bytesRead = 0;
                // I couldn't figure out how to get ERRNO_CODES included
                // so just hardcode the actual value
                // https://github.com/emscripten-core/emscripten/blob/565fb3651ed185078df1a13b8edbcb6b2192f29e/system/include/wasi/api.h#L146
                // https://github.com/emscripten-core/emscripten/blob/565fb3651ed185078df1a13b8edbcb6b2192f29e/system/lib/libc/musl/arch/emscripten/bits/errno.h#L13
                throw new sql.FS.ErrnoError(6 /* EAGAIN */);
            }
            this.bytesRead += bytes;
        };
        const lazyFiles = new Map();
        const hydratedConfigs = await fetchConfigs(configs);
        let mainFileConfig;
        for (const { config, virtualFilename } of hydratedConfigs) {
            const id = config.serverMode === "chunked" ? config.urlPrefix : config.url;
            console.log("constructing url database", id);
            let rangeMapper;
            let suffix = config.cacheBust ? "?cb=" + config.cacheBust : "";
            if (config.serverMode == "chunked") {
                rangeMapper = (from, to) => {
                    const serverChunkId = (from / config.serverChunkSize) | 0;
                    const serverFrom = from % config.serverChunkSize;
                    const serverTo = serverFrom + (to - from);
                    return {
                        url: config.urlPrefix + String(serverChunkId).padStart(config.suffixLength, "0") + suffix,
                        fromByte: serverFrom,
                        toByte: serverTo,
                    };
                };
            }
            else {
                rangeMapper = (fromByte, toByte) => ({
                    url: config.url + suffix,
                    fromByte,
                    toByte,
                });
            }
            const filename = virtualFilename || id.replace(/\//g, "_");
            if (!mainVirtualFilename) {
                mainVirtualFilename = filename;
                mainFileConfig = config;
            }
            console.log("filename", filename);
            console.log("constructing url database", id, "filename", filename);
            const lazyFile = lazyFile_1.createLazyFile(sql.FS, "/", filename, true, true, {
                rangeMapper,
                requestChunkSize: config.requestChunkSize,
                fileLength: config.serverMode === "chunked"
                    ? config.databaseLengthBytes
                    : undefined,
                logPageReads: true,
                maxReadHeads: 3,
                requestLimiter
            });
            lazyFiles.set(filename, lazyFile);
        }
        this.db = new sql.CustomDatabase(mainVirtualFilename);
        if (mainFileConfig) {
            // verify page size and disable cache (since we hold everything in memory anyways)
            const pageSizeResp = await this.db.exec("pragma page_size; pragma cache_size=0");
            const pageSize = pageSizeResp[0].values[0][0];
            if (pageSize !== mainFileConfig.requestChunkSize)
                console.warn(`Chunk size does not match page size: pragma page_size = ${pageSize} but chunkSize = ${mainFileConfig.requestChunkSize}`);
        }
        this.db.lazyFiles = lazyFiles;
        this.db.create_vtab(vtab_1.SeriesVtab);
        this.db.query = (...args) => toObjects(this.db.exec(...args));
        return this.db;
    },
    getResetAccessedPages(virtualFilename) {
        if (!this.db)
            return [];
        const lazyFile = this.db.lazyFiles.get(virtualFilename || this.db.filename);
        if (!lazyFile)
            throw Error("unknown lazy file");
        const pages = [...lazyFile.contents.readPages];
        lazyFile.contents.readPages = [];
        return pages;
    },
    getStats(virtualFilename) {
        const db = this.db;
        if (!db)
            return null;
        const lazyFile = db.lazyFiles.get(virtualFilename || db.filename);
        if (!lazyFile)
            throw Error("unknown lazy file");
        const res = {
            filename: db.filename,
            totalBytes: lazyFile.contents.length,
            totalFetchedBytes: lazyFile.contents.totalFetchedBytes,
            totalRequests: lazyFile.contents.totalRequests,
        };
        return res;
    },
    async evalCode(code) {
        return await eval(`(async function (db) {
      ${code}
    })`)(this.db);
    },
};
Comlink.expose(mod);
